import ApiBudgety from '@/api/apiBudgety'

export const estadoHitoService = {
  getAll,
}

async function getAll() {
  return await ApiBudgety.get('EstadoHito/GetAll')
}
